import styled from 'styled-components'

const GridTable = styled.section`
  table {
    table-layout: auto;
  }

  table td {
    border: 0px solid transparent;
    background-clip: padding-box;
  }

  table th:not(:first-child) {
    padding: 0 30px;
  }

  tr > td + td {
    border-left-width: 10px;
  }

  tr + tr > td {
    border-top-width: 10px;
  }
`

export default GridTable
